import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { KEY_NUMPAD_ADD, KEY_NUMPAD_SUBTRACT, KEY_MINUS, KEY_EQUAL, KEY_ESC, KEY_ENTER, KEY_NUMPAD_ENTER, TEXTAREA_TEXTINPUTDIV_ID } from '@/constants';
import { checkCtrlPressed, isWebComponentEnvironment, getElementByGetElementById } from '@/helpers';
import { setFloatableInputVisible, clearSelectedSections, setShowInsertModalState } from '@/actions';

export default props => {
  const { isFloatableTextareaAvailable, isEditModeEnabled } = props;
  const isShowInsertModal = useSelector(state => state.core.isShowInsertModal);
  const dispatch = useDispatch();
  const webComponent = isWebComponentEnvironment();

  useEffect(() => {
    if (webComponent) {
      document.addEventListener('keydown', handleKeydown);
    }

    return () => {
      if (webComponent) {
        document.removeEventListener('keydown', handleKeydown);
      }
    };
  });

  const handleSelectionClear = () => {     
    getElementByGetElementById(TEXTAREA_TEXTINPUTDIV_ID)?.blur();

    if (isShowInsertModal) {
      dispatch(setShowInsertModalState(false));
    } else if (isEditModeEnabled) {
      dispatch(setFloatableInputVisible(false));
    } else {
      dispatch(clearSelectedSections());
    }
  };

  const handleKeydown = event => {
    if (checkCtrlPressed(event) && [KEY_NUMPAD_ADD, KEY_NUMPAD_SUBTRACT, KEY_MINUS, KEY_EQUAL].includes(event.code)) {
      event.preventDefault();
    }

    if (event.code === KEY_ESC) {
      handleSelectionClear();
    }

    if ([KEY_ENTER, KEY_NUMPAD_ENTER].includes(event.code)) {
      if (isFloatableTextareaAvailable && !isEditModeEnabled) {
        event.preventDefault();
        dispatch(setFloatableInputVisible(true));
      }
    }
  };
};
